import { render, staticRenderFns } from "./TableDomains.vue?vue&type=template&id=26c850f0&"
import script from "./TableDomains.vue?vue&type=script&lang=js&"
export * from "./TableDomains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports